<div class="live-aution-section mt-5">
  <div class="container-one">
    <div
      class="row mb-60 wow animate fadeInDown"
      data-wow-delay="200ms"
      data-wow-duration="1500ms"
      >
      <div
        class="col-lg-12 d-flex align-items-center justify-content-between flex-wrap gap-3"
        >
        <div class="section-title">
          <h2>
            <span>{{
              displayType == "upcoming"
              ? ("buyer_homepage.title_part1_upcoming" | translate)
              : displayType == "active"
              ? ("buyer_homepage.title_part1_live" | translate)
              : ("buyer_homepage.title_part1_previous" | translate)
            }}</span>&ngsp;<span>{{
              displayType == "upcoming"
              ? ("buyer_homepage.title_part2_upcoming" | translate)
              : displayType == "active"
              ? ("buyer_homepage.title_part2_live" | translate)
              : ("buyer_homepage.title_part2_previous" | translate)
            }}</span>
          </h2>
          <p>
            {{
            displayType == "upcoming"
            ? ("buyer_homepage.upcoming_horses_note" | translate)
            : displayType == "active"
            ? ("buyer_homepage.live_horses_note" | translate)
            : ("buyer_homepage.previous_horses_note" | translate)
            }}
          </p>
        </div>
        <div class="slider-btn-grp">
          <div class="slider-btn auction-slider-prev">
            <svg
              width="9"
              height="15"
              viewBox="0 0 9 15"
              xmlns="http://www.w3.org/2000/svg"
              >
              <path d="M0 7.50009L9 0L3.27273 7.50009L9 15L0 7.50009Z" />
            </svg>
          </div>
          <div class="slider-btn auction-slider-next">
            <svg
              width="9"
              height="15"
              viewBox="0 0 9 15"
              xmlns="http://www.w3.org/2000/svg"
              >
              <path d="M9 7.50009L0 0L5.72727 7.50009L0 15L9 7.50009Z" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div
      class="auction-slider-area mb-70 wow animate fadeInUp"
      data-wow-delay="200ms"
      data-wow-duration="1500ms"
      [attr.direction]="dir"
      >
      <div class="row">
        <div class="col-lg-12">
          <div class="swiper auction-slider">
            <div class="swiper-wrapper">
              @if (!isLoading) {
                @for (horse of cardAuctions; track horse) {
                  <div class="swiper-slide">
                    <app-auction-item-card
                      (click)="cardClicked($event, horse)"
                      [showType]="true"
                      [loggedIn]="loggedIn"
                      [data]="horse"
                      [auctionType]="horse?.auctionType"
                      [auctionSettings]="horse?.auction_settings"
                      (timeEnded)="handleTimeEnded($event)"
                      [userId]="user_id"
                      [gradualEnding]="horse?.auction?.gradual_ending_settings"
                      [dir]="localeService.dir$ | async"
                      [auction]="horse?.auction"
                    [horseOffers]="{
                      offers: horse?.offers,
                      make_an_offer: horse?.make_an_offer
                    }"
                      (loadData)="loadDataEmit()"
                      [locale]="locale"
                      (favoriteClicked)="onFavoriteClick($event)"
                      [showHip]="false"
                      [showAuctionName]="false"
                      [showSeller]="true"
                      [isUpcomingTimer]="true"
                    ></app-auction-item-card>
                  </div>
                }
              }
              @if (isLoading) {
                @for (item of [1, 2, 3, 4, 5]; track item) {
                  <div
                    class="col-md-4 col-9 ms-3"
                    >
                    <app-skeleton-loader
                      class="swiper-slide"
                      type="auction-card"
                    ></app-skeleton-loader>
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (!isLoading && cardAuctions?.length == 0) {
      <app-no-data
        [showImg]="true"
      [message]="{
        message: 'buyer_homepage.no_live_horses_available' | translate,
        translationsKey: 'buyer_homepage_no_live_horses_available'
      }"
      [subMessage]="{
        subMessage: '',
        translationsKey: ''
      }"
      ></app-no-data>
    }
    @if (!isLoading) {
      <div
        class="row wow animate fadeInUp"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
        >
        <div class="col-lg-12 d-flex justify-content-center">
          <a
            class="view-button"
            (click)="goToAuctions()"
          [attr.data-translation-key]="
            cardAuctions.length > 0
              ? 'buyer_homepage_view_all_auctions'
              : cardAuctions.length == 0 && has_upcoming_auctions
              ? ' buyer_homepage_view_upcoming_auctions'
              : cardAuctions.length == 0 && !has_upcoming_auctions
              ? 'buyer_homepage_view_previous_auctions'
              : ''
          "
            >
            {{
            cardAuctions.length > 0
            ? ("buyer_homepage.view_all_auctions" | translate)
            : cardAuctions.length == 0 && has_upcoming_auctions
            ? ("buyer_homepage.view_upcoming_auctions" | translate)
            : cardAuctions.length == 0 && !has_upcoming_auctions
            ? ("buyer_homepage.view_previous_auctions" | translate)
            : ""
            }}
            <svg viewBox="0 0 13 20">
              <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5"></polyline>
            </svg>
          </a>
        </div>
      </div>
    }
  </div>
</div>
